function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBookmarkSolid = function SvgBookmarkSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24512"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2608",
    d: "M5 4.333A1.333 1.333 0 0 1 6.333 3H13a1.333 1.333 0 0 1 1.333 1.333V15l-4.666-2.333L5 15z",
    transform: "translate(-.667 .5)",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
};

export default SvgBookmarkSolid;